/**
 * 是否应在 translation-review 自动触发字幕机翻。
 * 只看 pipeline_stage，不要用 WorkItem.status：被指派人 Task 为 processing 时
 * status 也会是 processing，会误触发机翻并弹出「翻译完成」。
 *
 * 机翻未完成：subtitles_ready（原文就绪）/ failed（可重试）
 * 机翻已完成或委托中：workspace_ready / awaiting_review / in_review / completed → 不自动开翻
 */
export function shouldAutoStartSubtitleMachineTranslation(
  pipelineStage: string | null | undefined,
  translationAlreadyStarted: boolean,
): boolean {
  if (translationAlreadyStarted) return false
  return pipelineStage === 'subtitles_ready' || pipelineStage === 'failed'
}
